
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { PageItemProps } from ".";
import { loading, endLoading } from "store/page";

interface ApiPageRemoveInputProps {
    ids: number[]
}

type ApiPageRemoveOutputProps = OutputBaseProps<{ item: PageItemProps; }>

export const apiPageRemove = async (data: ApiPageRemoveInputProps) => {
    store.dispatch(loading());
    const res = (await axios.delete<ApiPageRemoveOutputProps>("/api/page/remove", { data }))
        .data;
    store.dispatch(endLoading());
    return res;
};